// auto-generated by Typewriter template _enums.tst from PortCall.Pilots.EndPoints\App\DispatchDashboard\MissingPilotJobOrdersViewModel.cs
export enum MissingPilotJobOrderType { 
    In = 0,
    Shift = 1,
    Out = 2
}

export const MissingPilotJobOrderTypeDisplayName : { [val : number] : string } = { 
    0: 'In',
    1: 'Shift',
    2: 'Out'
}

export const MissingPilotJobOrderTypes : { Id : MissingPilotJobOrderType, Name : string }[] = [ 
    { Id: MissingPilotJobOrderType.In, Name: 'In' },
    { Id: MissingPilotJobOrderType.Shift, Name: 'Shift' },
    { Id: MissingPilotJobOrderType.Out, Name: 'Out' }
]



// WEBPACK FOOTER //
// ./server/enums/MissingPilotJobOrderType.ts